import { CountryCode } from '../enum/country-code'
import { Category } from '../enum/site-category'
import { Deletable } from '../interface/deletable'
import { Factory } from '../interface/factory'
import { Identifiable } from '../interface/identifiable'
import { Modifiable } from '../interface/modifiable'
import { ContactPerson } from './contact-person'
import { I18nString } from './i18nstring'
import { Settings } from './settings'
import { Recipient, Snapshot } from './watchdog'
import { applyEntitySchema } from '../../_utils/fcdc-v2'
import { isPlainObject } from '../../_utils/fcdc-v2/json'
import { SiteSchema } from '../schema/owners.schema'

export { Category }

export class Site implements Identifiable, Deletable, Modifiable {
  id: string
  customerId: string
  presenceId: string
  pollable: boolean
  settings?: Settings
  category: Category
  names: I18nString[]
  countryCode: CountryCode

  province?: string
  postcode: string
  city: string
  address: string
  timezone: string

  serviceRepresentative?: ContactPerson
  technician?: ContactPerson
  contactPersons?: ContactPerson[]
  watchdogRecipients?: Recipient[]
  watchdogSnapshot?: Snapshot
  supportInfos?: I18nString[]

  deleted: boolean
  created: Date
  modified: Date

  constructor(json: any) {
    this.id = json.id
    this.customerId = json.customerId
    this.presenceId = json.presenceId
    this.pollable = json.pollable ? Boolean(json.pollable) : false
    this.settings = isPlainObject(json.settings)
      ? new Settings(json.settings)
      : undefined
    this.category = json.category ? json.category : Category.Unspecified
    this.names = Array.isArray(json.names)
      ? json.names.map((name: any) => new I18nString(name))
      : []
    this.countryCode = json.countryCode

    this.province = json.province
    this.postcode = json.postcode
    this.city = json.city
    this.address = json.address
    this.timezone = json.timezone

    this.serviceRepresentative = isPlainObject(json.serviceRepresentative)
      ? new ContactPerson(json.serviceRepresentative)
      : undefined
    this.technician = isPlainObject(json.technician)
      ? new ContactPerson(json.technician)
      : undefined
    this.contactPersons = Array.isArray(json.contactPersons)
      ? json.contactPersons.map((cp: any) => new ContactPerson(cp))
      : undefined
    this.watchdogRecipients = Array.isArray(json.watchdogRecipients)
      ? json.watchdogRecipients.map((recipient: any) =>
          Recipient.fromJson(recipient)
        )
      : undefined
    this.watchdogSnapshot = isPlainObject(json.watchdogSnapshot)
      ? new Snapshot(json.watchdogSnapshot)
      : undefined
    this.supportInfos = Array.isArray(json.supportInfos)
      ? json.supportInfos.map((s: any) => new I18nString(s))
      : undefined

    this.deleted = json.deleted ? Boolean(json.deleted) : false
    this.created = new Date(json.created)
    this.modified = new Date(json.modified)
    applyEntitySchema(this, SiteSchema, json, {
      category: Category.Unspecified,
      names: [],
      settings: undefined,
      province: undefined,
      serviceRepresentative: undefined,
      technician: undefined,
      contactPersons: undefined,
      watchdogRecipients: undefined,
      watchdogSnapshot: undefined,
      supportInfos: undefined,
    })
  }

  public static getFactory(): Factory<Site> {
    return new (class implements Factory<Site> {
      make(json: any): Site {
        return new Site(json)
      }

      getTableName(): string {
        return 'sites'
      }
    })()
  }

  static getUrl(siteId?: string): string {
    return '/sites' + (siteId ? '/' + siteId : '')
  }
}
